import { useEffect, useState } from 'react';
import '@/App.css';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { initSmoothScroll } from '@/lib/smoothScroll';
import { Preloader } from '@/components/Preloader';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Hero } from '@/components/sections/Hero';
import { LocationsMarquee } from '@/components/sections/LocationsMarquee';
import { About } from '@/components/sections/About';
import { Strength } from '@/components/sections/Strength';
import { Projects } from '@/components/sections/Projects';
import { Timeline } from '@/components/sections/Timeline';
import { CTA } from '@/components/sections/CTA';

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const lenis = initSmoothScroll();
    return () => lenis?.destroy();
  }, []);

  useEffect(() => {
    if (ready) {
      document.body.style.overflow = '';
      window.__lenis?.start();
      ScrollTrigger.refresh();
    } else {
      document.body.style.overflow = 'hidden';
      window.__lenis?.stop();
    }
  }, [ready]);

  return (
    <div className="bg-void text-ink min-h-screen">
      <div className="noise-overlay" />
      <Preloader onComplete={() => setReady(true)} />
      <Navbar visible={ready} />
      <main>
        <Hero started={ready} />
        <LocationsMarquee />
        <About />
        <Strength />
        <Projects />
        <Timeline />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
